class BGallerySegments extends HTMLElement {
  connectedCallback() {
    const slider = document.getElementById(this.dataset.slider);
    if (!slider) return;
    this.segments = [...this.querySelectorAll('span')];
    slider.addEventListener('slideChanged', (e) => this.setActive(e.detail.currentPage - 1));
  }

  setActive(index) {
    this.segments.forEach((s, i) => s.classList.toggle('is-active', i === index));
  }
}
if (!customElements.get('b-gallery-segments')) customElements.define('b-gallery-segments', BGallerySegments);
